import designItem from './DesignSearchItem.vue'
const DesignSearchItem = {
  install: function (Vue) {
    Vue.component('DesignSearchItem', designItem)
  }
}
export default DesignSearchItem
